import React, { Component } from 'react';
import { apiGet } from '../../Api';

export default class ItemTypeDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageFile: null,

            itemtype: null
        };
    }


    componentDidUpdate = async (prevProps, prevState) => {
        console.log("update");
        if (this.props.itemtypeId !== prevProps.itemtypeId || this.props.creatingNewItemType !== prevProps.creatingNewItemType) {
            this.setState({ imageFile: null, imagePreviewUrl: null });
            this.getItemType();

        }
    }


    getItemType = async () => {
        if (this.props.itemtypeId != null) {
            if (this.props.itemtypeId === "") {
                // this.setState({ itemtype: null });
                this.setState({
                    itemtype: {
                        name: "",
                        shortName: "",
                        flavourText: "",
                        orderIndex: 100,
                        imageId: "",
                        itemTypeSlots: 1,
                        isEquipment: false,
                        alwaysEquipped: false,
                        isStackable: false,
                        isConsumable: false,
                        implicitStatIds: [],
                        possibleAffixStatIds: [],
                    },
                    imageFile: null,
                    imagePreviewUrl: "",
                });
            }
            else {
                const response = await apiGet("/itemtype/" + this.props.itemtypeId);
                if (response.ok) {
                    const curr = await response.json();
                    this.setState({ itemtype: curr });
                    if (curr.imageId) {
                        this.fetchImage();
                    }
                }
            }
        }
        else {
            this.setState({ itemtype: null });
        }
    }

    handleInputChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        } else if (event.target.type === "number") {
            const parsed = Number.parseInt(event.target.value, 10);
            value = Number.isFinite(parsed) ? parsed : 0;
        }
        const itemtype = { ...this.state.itemtype, [name]: value };
        this.setState({ itemtype });
    };

    addAnotherStat = (event) => {
        const { name, value } = event.target;
        if (!value || value === "default") {
            return;
        }

        const existingStats = this.state.itemtype?.[name] ?? [];
        if (existingStats.includes(value)) {
            return;
        }

        const updatedStats = [...existingStats, value];
        this.setState({ itemtype: { ...this.state.itemtype, [name]: updatedStats } });
    }

    removeStat = (fieldName, statId) => {
        const currentIds = this.state.itemtype?.[fieldName] ?? [];
        this.setState({
            itemtype: {
                ...this.state.itemtype,
                [fieldName]: currentIds.filter(id => id !== statId),
            },
        });
    }

    renderStatPool = (title, fieldName, stats) => (
        <div className='section2'>
            <h3>{title}:</h3>
            {(this.state.itemtype?.[fieldName] ?? []).map((statId) => {
                const stat = stats.find(candidate => candidate.id === statId);
                return (
                    <div className='statEntryDefinition' key={`${fieldName}-${statId}`}>
                        <span>{stat?.name || statId}</span>
                        <button
                            type="button"
                            onClick={() => this.removeStat(fieldName, statId)}
                        >
                            delete
                        </button>
                    </div>
                );
            })}
            <label>Add another stat/proc:
                <select
                    name={fieldName}
                    value="default"
                    onChange={this.addAnotherStat}
                >
                    <option value="default">Add Stat</option>
                    {stats.map((stat) => (
                        <option key={stat.id} value={stat.id}>{stat.name}</option>
                    ))}
                </select>
            </label>
        </div>
    );


    render() {
        const { onUpdate, onDelete, onCreate, creatingNewItemType, onCancelCreate, stats } = this.props;
        const { itemtype } = this.state;

        if (!itemtype || itemtype == null) return <div>Select a itemtype to see details</div>;

        return (
            <div className='admin_details'>
                <label>Name:
                    <input type="text" name="name" value={itemtype.name} onChange={this.handleInputChange} />
                </label>
                <label>ItemType Slots:
                    <input type="number" name="itemTypeSlots" value={itemtype.itemTypeSlots} onChange={this.handleInputChange} />
                </label>
                <label>Is Equipment:
                    <input type="checkbox" name="isEquipment" checked={itemtype.isEquipment} onChange={this.handleInputChange} />
                </label>
                <label>Always Equiped (like special item that only has to be in inventory):
                    <input type="checkbox" name="alwaysEquipped" checked={itemtype.alwaysEquipped} onChange={this.handleInputChange} />
                </label>
                <label>Stackable:
                    <input type="checkbox" name="isStackable" checked={itemtype.isStackable} onChange={this.handleInputChange} />
                </label>
                <label>Consumable:
                    <input
                        type="checkbox"
                        name="isConsumable"
                        checked={Boolean(itemtype.isConsumable)}
                        onChange={this.handleInputChange}
                    />
                    <small>Consumable item types must be stackable and cannot be equipment.</small>
                </label>

                {this.renderStatPool("Implicit Stats", "implicitStatIds", stats)}
                {this.renderStatPool("Possible Affix Stats", "possibleAffixStatIds", stats)}

                {creatingNewItemType ?
                    <div>
                        {/* Form to create a new itemtype, similar to the update form... */}
                        <button onClick={() => onCreate(itemtype)}>Create</button>
                        <button onClick={() => onCancelCreate()}>Cancel</button>
                    </div>
                    :
                    <div>
                        <button onClick={() => onUpdate(itemtype)}>Update</button>
                        <button onClick={() => onDelete(itemtype)}>Delete</button>
                    </div>
                }


            </div>
        );


    }

}
